/* maven-product-qty — put the shared serving count in place of Dawn's quantity
 * picker and Add to cart button on the product page.
 *
 * Reads its product from the mount that sections/maven-product-qty.liquid
 * renders. Does nothing, and leaves Dawn's form working, when the product is
 * sold out, has options, or the page has no main product form.
 */
(function () {
  'use strict';

  function init() {
    var mount = document.querySelector('[data-maven-product-qty]');
    var Cart = window.MavenCart;
    if (!mount || !Cart) return;
    if (mount.getAttribute('data-available') !== 'true') return;
    if (mount.getAttribute('data-single-variant') !== 'true') return;
    var variantId = mount.getAttribute('data-variant-id');
    if (!variantId) return;

    /* The main product only: its product-info carries the MainProduct- id.
     * Recommendation cards and a featured product elsewhere are left alone. */
    var info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!info) return;
    var buttons = info.querySelector('product-form .product-form__buttons');
    if (!buttons) return;
    var quantity = info.querySelector('[id^="Quantity-Form-"]');

    var control = Cart.quantityControl({
      variantId: variantId,
      name: mount.getAttribute('data-name') || 'this dish',
      addClass: 'product-form__submit button button--full-width',
      addHtml: 'Add to cart',
      modifier: 'mv-dish__buy--product'
    });

    buttons.parentNode.insertBefore(control, buttons);
    buttons.hidden = true;
    buttons.style.display = 'none';
    if (quantity) {
      quantity.hidden = true;
      quantity.style.display = 'none';
    }

    Cart.read();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
}());
